import { buildPath } from "../../../helpers/string";
import { PermissionEnum } from "../../../modules/permission/enum";
import { root } from "./root";

export const workload = {
  path: "workload",
  getLink: () => buildPath([root.path, workload.path]),
  permissions: [PermissionEnum.WORKFORCE_MANAGEMENT_ACCESS],
};
